import i18n from '../../i18n/i18n';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import {
  ICreateOrganizationAdminPayload,
  IUpdateOrganizationAdminPayload,
  IOrganizationAdminListResponse,
  IOrganizationAdmin,
  IOrganizationAdminDeleteResponse,
} from '../../interface/organization-admin.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { organizationAdminService } from '../../services/organizationAdmin';

export const getOrganizationAdmins = createAsyncThunk<
  IOrganizationAdminListResponse,
  { page: number; pageSize: number; search?: string },
  { rejectValue: IErrorResponse }
>('organizationAdmin/getAll', async (params, { rejectWithValue }) => {
  try {
    const response = await organizationAdminService.getOrganizationAdmins(params);
    return response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue(
        error.response?.data || {
          message: i18n.t('msg.an_unknown_error_occurred', 'An unknown error occurred'),
        },
      );
    }
    return rejectWithValue({ message: err.message });
  }
});

export const createOrganizationAdmin = createAsyncThunk<
  IOrganizationAdmin,
  ICreateOrganizationAdminPayload,
  { rejectValue: IErrorResponse }
>('organizationAdmin/create', async (payload, { rejectWithValue }) => {
  try {
    const response = await organizationAdminService.createOrganizationAdmin(payload);
    return response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue(
        error.response?.data || {
          message: i18n.t('msg.an_unknown_error_occurred', 'An unknown error occurred'),
        },
      );
    }
    return rejectWithValue({ message: err.message });
  }
});

const updateOrganizationAdmin = createAsyncThunk<
  IOrganizationAdmin,
  { id: string; payload: IUpdateOrganizationAdminPayload },
  { rejectValue: IErrorResponse }
>('organizationAdmin/update', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const response = await organizationAdminService.updateOrganizationAdmin(id, payload);
    return response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue(
        error.response?.data || {
          message: i18n.t('msg.an_unknown_error_occurred', 'An unknown error occurred'),
        },
      );
    }
    return rejectWithValue({ message: err.message });
  }
});

const deleteOrganizationAdmin = createAsyncThunk<
  IOrganizationAdminDeleteResponse,
  string,
  { rejectValue: IErrorResponse }
>('organizationAdmin/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await organizationAdminService.deleteOrganizationAdmin(id);
    return response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IErrorResponse>;
      return rejectWithValue(
        error.response?.data || {
          message: i18n.t('msg.an_unknown_error_occurred', 'An unknown error occurred'),
        },
      );
    }
    return rejectWithValue({ message: err.message });
  }
});

export const organizationAdminActions = {
  getOrganizationAdmins,
  createOrganizationAdmin,
  updateOrganizationAdmin,
  deleteOrganizationAdmin,
};
